class QuickBuy {
    constructor() {
        this.selectors = {
            triggers: document.querySelectorAll('[data-quick-buy]'),
            modal: document.querySelector('.modal-content'),
            inner: document.querySelector('.modal-content__inner'),
            overlay: document.querySelector('[data-modal-overlay]'),
            close: document.querySelector('[data-modal-close]')
        };

        this.init();
    }

    init() {
        if (!this.selectors.modal) return;

        this.selectors.triggers.forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                const handle = trigger.dataset.quickBuy;
                this.loadProduct(handle, trigger);
            });
        });

        this.selectors.close.addEventListener('click', () => this.closeModal());
        this.selectors.overlay.addEventListener('click', () => this.closeModal());
    }

    loadProduct(handle, trigger) {
        if(trigger) trigger.classList.add('loading');

        fetch(`/products/${handle}.js`)
            .then(response => response.json())
            .then(product => {
                if (product.variants.length === 1 && product.variants[0].available) {
                    this.addToCartSingle(product.variants[0].id, trigger);
                } else {
                    if(trigger) trigger.classList.remove('loading');
                    this.selectors.inner.innerHTML = '';
                    this.openModal();
                    this.renderProduct(product);
                }
            })
            .catch(error => {
                if(trigger) trigger.classList.remove('loading');
                console.error(error);
            });
    }

    addToCartSingle(variantId, trigger) {
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);

        fetch('/cart/add.js', {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            if(trigger) trigger.classList.remove('loading');
            document.dispatchEvent(new Event('cart:refresh'));
        })
        .catch(err => {
            if(trigger) trigger.classList.remove('loading');
            console.error(err);
        });
    }

    formatMoney(cents) {
        let value = (cents / 100).toFixed(2);
        let format = window.theme.moneyFormat;
        
        let formattedString = format
            .replace(/\{\{\s*amount\s*\}\}/g, value)
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, value.replace('.00', ''))
            .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','))
            .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, value.replace('.00', '').replace('.', ','));

        return formattedString;
    }

    getResizedImage(src, size) {
        if (!src) return '';
        return src.replace(/(\.[^.]*)(?=\?v=|$)/, `_${size}$1`);
    }

    renderProduct(product) {
        const currentVariant = product.variants[0];
        const strings = window.theme.strings;

        let imagesHtml = '';
        product.images.forEach(image => {
            const resizedSrc = this.getResizedImage(image, '600x');
            imagesHtml += `
                <div class="swiper-slide">
                    <figure><img src="${resizedSrc}" alt="${product.title}"></figure>
                </div>
            `;
        });

        let optionsHtml = '<div class="product__options">';
        product.options.forEach((option, index) => {
            let valuesHtml = '';
            const optionIndex = index + 1;
            
            option.values.forEach((value, vIndex) => {
                const isChecked = vIndex === 0 ? 'checked' : '';
                const cleanValue = value.replace(/"/g, '&quot;');
                const id = `Option${optionIndex}-${value.replace(/ /g, '-')}`;
                
                valuesHtml += `
                    <input type="radio" id="${id}" name="options[${option.name}]" value="${cleanValue}" ${isChecked}>
                    <label data-color="${cleanValue}" for="${id}">
                        <span style="position:relative;">${value}</span>
                    </label>
                `;
            });

            optionsHtml += `
                <div class="option option--${option.name.toLowerCase()}">
                    <div class="option__title">${option.name}</div>
                    <div class="option__input">
                        ${valuesHtml}
                    </div>
                </div>
            `;
        });
        optionsHtml += '</div>';

        const onSale = currentVariant.compare_at_price > currentVariant.price;
        const priceHtml = `
            <div class="price" data-price-wrapper>
                <span class="price__old" data-compare-price style="${onSale ? '' : 'display:none'}">
                    ${onSale ? this.formatMoney(currentVariant.compare_at_price) : ''}
                </span>
                <span class="price__current" data-product-price>
                    ${this.formatMoney(currentVariant.price)}
                </span>
            </div>
        `;

        const html = `
            <div class="quick-buy-wrapper">
                <div class="quick-buy-gallery">
                    <div class="swiper quick-buy-swiper">
                        <div class="swiper-wrapper">
                            ${imagesHtml}
                        </div>
                        <div class="swiper-pagination"></div>
                        <div class="swiper-button-prev"><svg width="15" height="7" viewBox="0 0 15 7" xmlns="http://www.w3.org/2000/svg"><path d="m1 0 6.5 7L14 0" stroke="#000" fill="none" fill-rule="evenodd"/></svg></div>
                        <div class="swiper-button-next"><svg width="15" height="7" viewBox="0 0 15 7" xmlns="http://www.w3.org/2000/svg"><path d="m1 0 6.5 7L14 0" stroke="#000" fill="none" fill-rule="evenodd"/></svg></div>
                    </div>
                </div>
                <div class="quick-buy-details">
                    <h3>${product.title}</h3>
                    ${priceHtml}
                    <div class="description">${product.description}</div>
                    
                    <form id="qb-form">
                        <input type="hidden" name="id" id="qb-variant-id" value="${currentVariant.id}">
                        ${optionsHtml}
                        <button type="submit" id="qb-submit" class="button"><span>${strings.addToCart}</span><svg viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="b"><stop stop-color="#fff" stop-opacity="0" offset="0%"/><stop stop-color="#fff" stop-opacity=".631" offset="63.146%"/><stop stop-color="#fff" offset="100%"/></linearGradient></defs><g fill="none" fill-rule="evenodd"><g transform="translate(1 1)"><path d="M36 18c0-9.94-8.06-18-18-18" id="Oval-2" stroke="url(#b)" stroke-width="2"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.9s" repeatCount="indefinite"/></path><circle fill="#fff" cx="36" cy="18" r="1"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.9s" repeatCount="indefinite"/></circle></g></g></svg></button>
                        <a href="${product.url}" class="button button--secondary">Przejdź do produktu</a>
                    </form>
                </div>
            </div>
        `;

        this.selectors.inner.innerHTML = html;
        
        const swiperEl = this.selectors.inner.querySelector('.quick-buy-swiper');
        if(swiperEl) {
            document.dispatchEvent(new CustomEvent('quickBuy:initSwiper', { 
                detail: { element: swiperEl } 
            }));
        }

        this.initFormListeners(product);
    }

    initFormListeners(product) {
        const form = document.getElementById('qb-form');
        const radios = form.querySelectorAll('input[type="radio"]');
        const priceCurrent = document.querySelector('[data-product-price]');
        const priceCompare = document.querySelector('[data-compare-price]');
        const variantInput = document.getElementById('qb-variant-id');
        const submitBtn = document.getElementById('qb-submit');
        const strings = window.theme.strings;

        const updateVariant = () => {
            const selectedValues = [];
            product.options.forEach((option) => {
                const checked = form.querySelector(`input[name="options[${option.name}]"]:checked`);
                if (checked) selectedValues.push(checked.value);
            });

            const matchedVariant = product.variants.find(variant => {
                return selectedValues.every((val, index) => variant.options[index] === val);
            });

            radios.forEach(radio => {
                const label = form.querySelector(`label[for="${radio.id}"]`);
                if (!label) return;

                const radioNameAttr = radio.name; 
                const optionIndex = product.options.findIndex(opt => `options[${opt.name}]` === radioNameAttr);

                if (optionIndex !== -1) {
                    const potentialSelection = [...selectedValues];
                    potentialSelection[optionIndex] = radio.value;

                    const checkVariant = product.variants.find(v => 
                        potentialSelection.every((val, i) => v.options[i] === val)
                    );

                    if (checkVariant && checkVariant.available) {
                        label.classList.remove('sold');
                    } else {
                        label.classList.add('sold');
                    }
                }
            });

            if (matchedVariant) {
                variantInput.value = matchedVariant.id;
                
                priceCurrent.innerHTML = this.formatMoney(matchedVariant.price);
                
                if (matchedVariant.compare_at_price > matchedVariant.price) {
                    priceCompare.innerHTML = this.formatMoney(matchedVariant.compare_at_price);
                    priceCompare.style.display = ''; 
                } else {
                    priceCompare.style.display = 'none';
                }

                if (matchedVariant.available) {
                    submitBtn.disabled = false;
                    submitBtn.querySelector('span').textContent = strings.addToCart;
                } else {
                    submitBtn.disabled = true;
                    submitBtn.querySelector('span').textContent = strings.soldOut;
                }
            } else {
                submitBtn.disabled = true;
                submitBtn.querySelector('span').textContent = strings.unavailable;
                priceCompare.style.display = 'none';
            }
        };

        radios.forEach(radio => radio.addEventListener('change', updateVariant));

        form.addEventListener('submit', (e) => {
            e.preventDefault();
            submitBtn.classList.add('loading');

            const formData = new FormData(form);

            fetch('/cart/add.js', {
                method: 'POST',
                body: formData
            })
            .then(response => response.json())
            .then(data => {
                submitBtn.classList.remove('loading');
                this.closeModal();
                document.dispatchEvent(new Event('cart:refresh'));
            })
            .catch(err => {
                submitBtn.classList.remove('loading');
                console.error(err);
            });
        });

        updateVariant();
    }

    openModal() {
        this.selectors.modal.classList.add('active');
        this.selectors.overlay.classList.add('active');
    }

    closeModal() {
        this.selectors.modal.classList.remove('active');
        this.selectors.overlay.classList.remove('active');
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new QuickBuy();
});